import { ISvgIcon } from './SvgIcon.interfaces';

const SvgIcon = ({ component: IconComponent, className = 'w-5 h-5' }: ISvgIcon) => {
  return <IconComponent className={className} />;
};

export default SvgIcon;
